import { terms } from '../language/terms';

/**
 * The plain-text name a person is shown by: their display name, trimmed, and never their username
 * (D-151, contact rule 8). A person stored with a blank display name, possible only for a row from
 * before the edit job refused a change to blank, reads as "Unnamed <user>".
 *
 * <user-name> uses it for the linked name, and the plain-text places rule 8 lists (a confirmation
 * message, an option in a picker, a page title) use it directly, so both read the same.
 */
export function personName(displayName: string | null | undefined): string {
  const name = displayName?.trim();
  return name ? name : `Unnamed ${terms.loginUser.lower}`;
}
